import { render, staticRenderFns } from "./actividades-proyecto-componente.vue?vue&type=template&id=6e5d421a"
import script from "./actividades-proyecto-componente.vue?vue&type=script&lang=js"
export * from "./actividades-proyecto-componente.vue?vue&type=script&lang=js"
import style0 from "./actividades-proyecto-componente.vue?vue&type=style&index=0&id=6e5d421a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports